module.exports = __webpack_public_path__ + "img/Trackprogress.26830c2b.png";